import FormLabel from '@mui/material/FormLabel';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';

interface Props {
	required?: boolean;
	title: string;
	id?: string;
	style?: any;
	htmlFor?: string;
}

const useStyles = makeStyles((theme) => ({
	labelAsterisk: {
		color: 'red',
	},
}));

const FieldLabel = ({ required, title, id, style, htmlFor }: Props) => {
	const classes = useStyles();
	return (
		<FormLabel
			id={id}
			required={required}
			classes={{ asterisk: classes.labelAsterisk }}
			htmlFor={htmlFor}
			sx={{
				lineHeight: 1,
				transform: 'translate(0, 1.5px) scale(0.75)',
				transformOrigin: 'top left',
				height: 'auto',
				color: 'black.darker',
				...style,
			}}
		>
			{title}
		</FormLabel>
	);
};

export default FieldLabel;
